export default __webpack_public_path__ + "static/media/sdr_compansation_preview.285372a3.png";